// Store with TypeScript
import { FastaFile } from "@domain/schemas/BI";
import { create } from "zustand";

interface FastaStore {
  selectedFasta?: FastaFile[];
  fastaList: FastaFile[];

  uploadResults: string;
  isUploadVisible: boolean;

  setSelectedFasta: (fasta: FastaFile[]) => void;
  setFastaList: (fastaList: FastaFile[]) => void;

  setUploadVisibilitiy: (uploadVisibilitiy: boolean) => void;
  setUploadResults: (uploadResults: string) => void;
}

export const useFastaStore = create<FastaStore>((set) => ({
  fastaList: [],
  uploadResults: "",
  isUploadVisible: false,

  setSelectedFasta: (selectedFasta: FastaFile[]) => set({ selectedFasta }),
  setFastaList: (fastaList: FastaFile[]) => set({ fastaList }),

  setUploadVisibilitiy: (isUploadVisible: boolean) => set({ isUploadVisible }),
  setUploadResults: (uploadResults: string) => set({ uploadResults }),
}));
